import { Button, Divider } from "antd";
import arrow from "../../assets/images/shaded-arrow.svg";
import cdssWallpaper from "../../assets/images/cdss-wallpaper.gif";
import tryGenRxIcon from "../../assets/images/try-gen-rx.svg";

const TabVoiceRx = ({ handleGenRxKnowMore, setIsGenRxDrawerVisible }) => {
  return (
    <div
      style={{
        height: "calc(-60px + 100vh)",
        overflow: "auto",
      }}
    >
      <>
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            rowGap: "24px",
            padding: "24px 10px",
            background: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${cdssWallpaper})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: "0 0 20px 20px",
          }}
        >
          <div className="d-flex flex-column align-items-center gap-2">
            <div
              style={{
                fontSize: 24,
                fontWeight: 600,
                lineHeight: "32px",
                textAlign: "center",
              }}
            >
              Voice Rx
            </div>
          </div>

          <span style={{ lineHeight: "26px", textAlign: "center" }}>
            Quickly generate structured prescriptions by combining voice and
            type inputs, reducing time and effort in high-volume consultations
          </span>
        </div>
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ padding: "0 10px", marginTop: 16, gap: 10 }}
        >
          <Button
            className="btn btn-primary3 btn-41 px-4 w-100 d-flex align-items-center"
            style={{ gap: 10 }}
            onClick={() => setIsGenRxDrawerVisible(true)}
          >
            <img src={tryGenRxIcon} alt="ddx-icon" />
            Try Voice Rx
          </Button>
        </div>
        <div style={{position: "absolute", bottom: 0}}>
          <Divider />
          <div style={{ padding: "0px 12px" }}>
            <div
              className="d-flex align-items-center"
              style={{ paddingBottom: 10, columnGap: 8 }}
              onClick={handleGenRxKnowMore}
            >
              <div className="text-primary" style={{ fontWeight: 600 }}>
                Know More About Voice Rx
              </div>
              <img src={arrow} alt="arrow" />
            </div>
            <div
              className="disclaimer-txt"
              style={{
                color: "#A2A2A8",
                fontWeight: 500,
                fontSize: 12,
                paddingBottom: 20,
              }}
            >
              <b style={{ fontWeight: 700 }}>Disclaimer</b>: These results are
              generated by AI. Please double-check all details to ensure they are
              correct and complete.
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default TabVoiceRx;
